import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn, Button } from './ui';
import { ShieldCheck, Check, Zap } from 'lucide-react';
export const Hero = () => {
  return <section className="relative pt-24 pb-20 md:pt-32 md:pb-32 px-6 overflow-hidden bg-cream-light" data-id="element-182">
      {/* Subtle background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-cream-dark/30 rounded-bl-full -z-10 blur-3xl opacity-50" data-id="element-183"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-1/2 bg-sage-light/40 rounded-tr-full -z-10 blur-3xl opacity-50" data-id="element-184"></div>

      <div className="max-w-6xl mx-auto" data-id="element-185">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-186">
          <div className="flex-1 text-center lg:text-left" data-id="element-187">
            <FadeIn data-id="element-188">
              <span className="inline-block py-1 px-3 rounded-full bg-gold-light text-brown-light text-sm font-bold tracking-wider uppercase mb-6" data-id="element-189">
                Para mujeres 50+
              </span>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-190">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 text-center" data-id="element-191">
                8 Horas Dormida.
                <span className="block text-gold italic font-normal" data-id="element-192">
                  Cero Descanso.
                </span>
              </h1>
              <p className="text-lg md:text-xl text-brown font-medium mb-6 max-w-2xl mx-auto lg:mx-0" data-id="element-193">
                Si te despiertas agotada todos los días, esto no es normal — y
                tiene solución.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-194">
              <p className="text-base md:text-lg text-brown-light mb-6 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-195">
                Descubre el Método de Micro-Sincronización Hormonal que está
                ayudando a mujeres de 50+ a recuperar su energía matutina en 21
                días — sin medicamentos, sin dietas extremas y sin rutinas
                imposibles.
              </p>

              <div className="mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-196">
                <p className="text-sm font-semibold text-brown-light/80 mb-3" data-id="element-197">
                  Diseñado con base en 3 principios validados:
                </p>
                <div className="space-y-1.5 text-sm text-brown-light/70" data-id="element-198">
                  <p className="flex items-start gap-2" data-id="element-199">
                    <Check className="w-4 h-4 text-sage mt-0.5 shrink-0" data-id="element-200" />
                    Cronobiología circadiana (Dr. Satchin Panda, Salk Institute)
                  </p>
                  <p className="flex items-start gap-2" data-id="element-201">
                    <Check className="w-4 h-4 text-sage mt-0.5 shrink-0" data-id="element-202" />
                    Eje hormonal cortisol-insulina (investigación
                    post-menopáusica)
                  </p>
                  <p className="flex items-start gap-2" data-id="element-203">
                    <Check className="w-4 h-4 text-sage mt-0.5 shrink-0" data-id="element-204" />
                    Regulación del nervio vago (neurociencia aplicada)
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-205">
              <div className="mb-8 lg:text-left text-center" data-id="element-206">
                <span className="text-sm text-brown-light uppercase tracking-wider font-bold" data-id="element-207">
                  Plan + 3 Bonos · Inversión única
                </span>
                <div className="flex items-baseline justify-center lg:justify-start gap-3 mt-1" data-id="element-208">
                  <span className="text-2xl text-brown-light/50 line-through font-medium" data-id="element-209">
                    $97
                  </span>
                  <span className="text-5xl font-bold text-coral" data-id="element-210">$17</span>
                  <span className="text-2xl text-brown-light font-normal" data-id="element-211">
                    USD
                  </span>
                </div>
                <span className="inline-flex items-center gap-1 mt-2 bg-sage-light text-sage text-sm font-bold px-3 py-1 rounded-full" data-id="element-212">
                  <Zap className="w-3.5 h-3.5" data-id="element-213" />
                  Ahorra más del 70%
                </span>
              </div>

              <Button className="mx-auto lg:mx-0" href="#cta-cierre" data-id="element-214">
                ¡SÍ, QUIERO RECUPERAR MI ENERGÍA AHORA!
              </Button>

              <div className="mt-6 bg-cream border border-cream-dark rounded-2xl p-6 text-center max-w-md mx-auto lg:mx-0" data-id="element-215">
                <ShieldCheck className="w-8 h-8 text-sage mx-auto mb-3" data-id="element-216" />
                <h4 className="font-bold text-brown mb-2 text-lg" data-id="element-217">
                  Garantía de 7 Días Sin Riesgo
                </h4>
                <p className="text-sm text-brown-light leading-relaxed" data-id="element-218">
                  Si en los próximos 7 días sientes que el Plan de 21 Días de
                  Vitalidad no fue para ti, te devolvemos cada centavo. Sin
                  preguntas. Sin burocracia. Tu confianza vale más que tu
                  dinero.
                </p>
              </div>

              <p className="mt-6 text-sm text-center lg:text-left text-brown-light/80" data-id="element-219">
                Acceso instantáneo tras la compra. Tu nueva vitalidad comienza
                mañana mismo.
              </p>
            </FadeIn>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none relative" data-id="element-220">
            <FadeIn delay={0.4} data-id="element-221">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-brown/10 aspect-[16/10]" data-id="element-222">
                <img src="https://cdn.magicpatterns.com/uploads/qfE7aXZCJfEgvzUdLV7b1P/eBook.png" alt="Plan de 21 Días de Vitalidad Menopáusica — Portada del ebook" className="w-full h-full object-contain bg-cream-light" data-id="element-223" />
              </div>

              {/* Badge below image */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: 0.8,
              type: 'spring'
            }} className="mt-6 mx-auto w-fit bg-white p-4 rounded-xl shadow-xl flex items-center gap-4 border border-cream-dark" data-id="element-224">
                <div className="w-12 h-12 bg-sage-light rounded-full flex items-center justify-center text-sage" data-id="element-225">
                  <Zap className="w-6 h-6" data-id="element-226" />
                </div>
                <div data-id="element-227">
                  <p className="text-sm font-bold text-brown" data-id="element-228">
                    Energía Estable
                  </p>
                  <p className="text-xs text-brown-light" data-id="element-229">En solo 21 días</p>
                </div>
              </motion.div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
};